export const ADD_RESERVATIONS = "ADD_RESERVATIONS";
export const UPDATE_APP_MODE = "UPDATE_APP_MODE";
export const SET_BLACKLIST = "SET_BLACKLIST";
export const SET_BLACKLIST_RECOVERY = "SET_BLACKLIST_RECOVERY";
export const SET_SUPER_BLACKLIST = "SET_SUPER_BLACKLIST";
export const SET_RECOVERY_PAYMENT_CLEARED = "SET_RECOVERY_PAYMENT_CLEARED";
export const SET_PROPERTY_FEES = "SET_PROPERTY_FEES";
export const SET_CURRENT_RESERVATION_ID = "SET_CURRENT_RESERVATION_ID";
